/**
 * AccountSignOut.jsx
 * Created by michaelbray on 2/14/18.
 */

import React from 'react';
import PropTypes from 'prop-types';

import * as Icons from '../../sharedComponents/icons/Icons';
import CartTimer from '../../sharedComponents/CartTimer';
import AccountProfileDropdown from './AccountProfileDropdown';

const propTypes = {
    cart: PropTypes.object,
    account: PropTypes.object,
    logout: PropTypes.func
};

const defaultProps = {
    cart: {
        showTimer: false
    }
};

export default class AccountSignOut extends React.Component {
    render() {
        let cartTimer = null;
        if (this.props.cart.showTimer) {
            cartTimer = <div className="rec-small-timer"><CartTimer date={new Date(this.props.cart.expiration)} /></div>;
        }

        return (
            <div className="nav-user-actions">
                {cartTimer}
                <a
                    href="/cart"
                    className="nav-interactions-link nav-interactions-link-cart">
                    <Icons.IconCart />
                </a>
                <AccountProfileDropdown
                    account={this.props.account}
                    signOut={this.props.logout} />
            </div>
        );
    }
}

AccountSignOut.propTypes = propTypes;
AccountSignOut.defaultProps = defaultProps;
